"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OMLocation {
    constructor(obj) {
        if (typeof obj === "string") {
            const [_, longitudeString, latitudeString] = obj.match(OMLocation.Regex);
            this.longitude = parseFloat(longitudeString);
            this.latitude = parseFloat(latitudeString);
        }
        else {
            this.latitude = obj.latitude;
            this.longitude = obj.longitude;
        }
    }
    toJSON() {
        return `POINT(${this.longitude} ${this.latitude})`;
    }
    toString() {
        return `POINT(${this.longitude} ${this.latitude})`;
    }
}
OMLocation.Regex = /Point\(([-0-9.]+)[, ]([-0-9.]+)\)/i;
exports.default = OMLocation;
//# sourceMappingURL=GeoAnnotation.js.map